import { gql } from 'graphql-tag';

export const SEO_ACCORDIONS_FRAGMENT = gql`
    fragment SEO_ACCORDIONS_FRAGMENT on SeoAccordions {
        category
        expanded
        geo
        name
        propertyType
        section
        transactionType
        rows {
            links {
                category
                geo
                propertyType
                section
                transactionType
                uri
            }
        }
        links {
            category
            geo
            propertyType
            section
            transactionType
            uri
        }
    }
`;
